module.exports = __webpack_public_path__ + "img/logo-decathlon.853b7f73.jpg";